/**
 * Метод загрузки модуля для добаления темы яндекс карт
 * @kind helper
 * @returns Промис получения стиля
 */
export const loadDefaultUIThemeCss = () =>
    import(/* webpackChunkName: "ymaps3-default-ui-theme.css" */ '@yandex/ymaps3-default-ui-theme/dist/esm/index.css');
